// ======================================================================
// File Name       : ContentQuestionAttributeAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import * as ActionTypes from '../../constants/actionTypes/question';
import * as questionAttributeRequests from '../httpRequests/content';
import { downloadFile } from '../../utils/index';

export function fetchQuestionAttributeList(param) {
  return dispatch =>
    questionAttributeRequests
      .postQuestionAttributeList({
        ...param,
      })
      .then(({ recordNum, questionAttributeIdList }) => {
        dispatch(receiveQuestionAttributeList(recordNum, questionAttributeIdList));
      });
}

export function receiveQuestionAttributeList(recordNum, questionAttributeIdList) {
  return {
    type: ActionTypes.QUESTION_ATTRIBUTE_LIST,
    recordNum,
    questionAttributeIdList,
  };
}

export function bulkRegistration(param) {
  return dispatch =>
    questionAttributeRequests
      .questionAttributePackageRegister({
        ...param,
      })
      .then((resdata) => {
        dispatch(
          receiveQuestionAttributePackageRegister(
            resdata,
            ActionTypes.QUESTION_ATTRIBUTE_PACKAGE_REGISTER,
          ),
        );
      });
}

export function receiveQuestionAttributePackageRegister(resdata, type) {
  return {
    type,
    resdata,
  };
}

export function exportQuestionAttributeIdListCSV(param) {
  return dispatch =>
    questionAttributeRequests
      .exportQuestionAttributeIdListCSV({
        ...param,
      })
      .then((resdata) => {
        if (resdata && resdata.zipfileUrl) {
          downloadFile(resdata.zipfileUrl);
        }
      });
}

